import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	width: "100%",
	height: "100%",
	style: {
		shapeRendering: "geometricPrecision",
		textRendering: "geometricPrecision",
		imageRendering: "optimizeQuality",
		fillRule: "evenodd",
		clipRule: "evenodd"
	},
	viewBox: "0 0 21590 27940",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Layer_x0020_1",
		children: [/* @__PURE__ */ _jsx("metadata", { id: "CorelCorpID_0Corel-Layer" }), /* @__PURE__ */ _jsx("g", {
			id: "_820554208",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "fil0",
					d: "M10860 2409c3400,3808 5976,7592 7135,12605 823,3558 -398,8005 -3816,9750 -3943,2013 -7338,662 -9656,-2540 -1469,-2030 -1695,-4838 -1008,-7197 1278,-4390 5514,-7745 7082,-12473 56,-170 126,-298 263,-145zm3586 23004l0 0c3859,-2114 5010,-6561 4195,-10680 -992,-5011 -4214,-9314 -7522,-13060 -623,-707 -802,-95 -991,452 -1742,5023 -6042,8522 -7280,12740 -763,2599 -438,5435 1080,7701 2380,3551 6658,4962 10518,2847z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "fil0",
					d: "M14188 21348c-256,0 -462,-389 -530,-593 -688,-2082 951,-5314 1733,-3558 207,464 173,972 173,1483 0,856 -591,2668 -1376,2668zm-818 285l0 0c168,209 416,351 754,398 263,37 612,-109 835,-277 1284,-971 1886,-4337 584,-5495 -844,-752 -1784,155 -2178,952 -599,1207 -896,3306 5,4422z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "fil0",
					d: "M13402 15395c-268,0 -263,-477 -181,-866 73,-349 204,-606 345,-762 211,-234 440,-250 520,300 73,501 -359,1328 -684,1328zm-926 -674l0 0c0,530 116,1214 738,1340 386,79 846,-140 1177,-632 1092,-1628 -301,-3495 -1511,-1904 -180,237 -404,786 -404,1196z",
					fill: "#808080"
				})
			] })
		})]
	})]
});
const ForwardRef = forwardRef(SvgOil);
export default ForwardRef;
